export type { GameAdapter } from './GameAdapter';
export type { StorageAdapter } from './StorageAdapter';
export { ServerAdapter } from './ServerAdapter';
export { ClientAdapter } from './ClientAdapter';
export { LocalStorageAdapter } from './LocalStorageAdapter';
export { FBStorageAdapter } from './FBStorageAdapter';
export { YouTubeStorageAdapter } from './YouTubeStorageAdapter';
export { RedditStorageAdapter } from './RedditStorageAdapter';

import type { GameAdapter } from './GameAdapter';
import { ServerAdapter } from './ServerAdapter';
import { ClientAdapter } from './ClientAdapter';
import { LocalStorageAdapter } from './LocalStorageAdapter';

export function createAdapter(
  mode: 'server' | 'client',
  baseUrl?: string,
  authToken?: string,
): GameAdapter {
  if (mode === 'server') {
    if (!baseUrl) {
      throw new Error('baseUrl required for server adapter');
    }
    return new ServerAdapter(baseUrl, authToken);
  }

  return new ClientAdapter(new LocalStorageAdapter());
}
